import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from 'bootstrap-icons/icons/clock.svg'
import _imports_1 from 'bootstrap-icons/icons/tag.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  width: "12",
  height: "12",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  width: "12",
  height: "12",
  src: _imports_1
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "comment-send-message" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" For writing comment ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" (email address remains anonymous) ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("h1", null, _toDisplayString(_ctx.$store.state.singleBlogItem?.name), 1),
    _createVNode("div", {
      class: "col-md-12 content-container",
      innerHTML: _ctx.content
    }, null, 8, ["innerHTML"]),
    _hoisted_1,
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.publicationDate) + " ", 1),
    _hoisted_3,
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_ctx.$store.state.singleBlogItem?.tags) + " ", 1),
    _hoisted_5,
    _createVNode("p", _hoisted_6, [
      _hoisted_7,
      _createVNode("a", {
        href: 
      'mailto:website-comment@saatsazov.com?subject=post: ' +
      _ctx.$store.state.singleBlogItem?.slug
    
      }, "send mail", 8, ["href"]),
      _hoisted_8
    ])
  ], 64))
}